import React from "react";
import { useTranslation } from "@/i18n/I18nProvider";

export default function CookiePolicy() {
  const { t, dict } = useTranslation();
  const rows = dict.cookie_policy?.rows || [];
  return (
    <div className="bg-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 lg:py-20">
        <p className="text-xs uppercase tracking-[0.24em] font-semibold text-blue-900 mb-3">
          {t("cookie_policy.updated")}
        </p>
        <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          {t("cookie_policy.title")}
        </h1>
        <p className="text-slate-600 leading-relaxed mt-6">{t("cookie_policy.intro")}</p>

        <section className="mt-10">
          <h2 className="text-xl font-semibold text-slate-900">
            {t("cookie_policy.definition_title")}
          </h2>
          <p className="text-slate-600 leading-relaxed mt-2">
            {t("cookie_policy.definition_body")}
          </p>
        </section>

        <section className="mt-10">
          <h2 className="text-xl font-semibold text-slate-900">
            {t("cookie_policy.table_title")}
          </h2>
          <div className="mt-4 overflow-x-auto border border-slate-200 rounded-lg">
            <table className="min-w-full text-sm" data-testid="cookie-table">
              <thead className="bg-slate-100 text-slate-800 text-left">
                <tr>
                  <th className="px-4 py-3 font-semibold">{t("cookie_policy.table_header_name")}</th>
                  <th className="px-4 py-3 font-semibold">{t("cookie_policy.table_header_purpose")}</th>
                  <th className="px-4 py-3 font-semibold">{t("cookie_policy.table_header_duration")}</th>
                  <th className="px-4 py-3 font-semibold">{t("cookie_policy.table_header_type")}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200 text-slate-700">
                {rows.map((r, i) => (
                  <tr key={i}>
                    <td className="px-4 py-3 font-mono text-xs">{r.name}</td>
                    <td className="px-4 py-3">{r.purpose}</td>
                    <td className="px-4 py-3">{r.duration}</td>
                    <td className="px-4 py-3">{r.type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="mt-10">
          <h2 className="text-xl font-semibold text-slate-900">
            {t("cookie_policy.manage_title")}
          </h2>
          <p className="text-slate-600 leading-relaxed mt-2">
            {t("cookie_policy.manage_body")}
          </p>
        </section>

        <section className="mt-10">
          <h2 className="text-xl font-semibold text-slate-900">
            {t("cookie_policy.consent_mode_title")}
          </h2>
          <p className="text-slate-600 leading-relaxed mt-2">
            {t("cookie_policy.consent_mode_body")}
          </p>
        </section>
      </div>
    </div>
  );
}
